import React from 'react';
import { 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  Toolbar, 
  Typography,
  Box,
  Divider
} from '@mui/material';
import { 
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  VerifiedUser as VerifiedIcon,
  PhotoLibrary as PhotoIcon,
  Payment as PaymentIcon,
  ReportProblem as ReportIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  Assignment as PackageIcon,
  AssignmentInd as AssignIcon  // Add this import
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { LocationOn as LocationIcon } from '@mui/icons-material';
import { Work as WorkIcon } from '@mui/icons-material';
import { School as SchoolIcon } from '@mui/icons-material';
import { BusinessCenter as BusinessCenterIcon } from '@mui/icons-material';
import { Church as ChurchIcon } from '@mui/icons-material';
import { Favorite as MatchIcon } from '@mui/icons-material';
import { SportsEsports as HobbiesIcon } from '@mui/icons-material';

// Add to menuItems

// Add to menuItems

// Add to menuItems

// Add to menuItems

// Add to menuItems

// Add to menuItems



const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
  { text: 'User Matching', icon: <MatchIcon />, path: '/matching' },

  { text: 'Users', icon: <PeopleIcon />, path: '/users' },
    { text: 'Add Users', icon: <PeopleIcon />, path: '/users/add' },

  { text: 'Document Verification', icon: <VerifiedIcon />, path: '/verification/documents' },
  { text: 'Photo Verification', icon: <PhotoIcon />, path: '/verification/photos' },
  { text: 'Payments', icon: <PaymentIcon />, path: '/payments/transactions' },
  { text: 'Packages', icon: <PaymentIcon />, path: '/payments/packages' },
  { text: 'User Packages', icon: <PackageIcon />, path: '/payments/user-packages' },
  { text: 'Reports', icon: <ReportIcon />, path: '/reports' },
  { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
  { text: 'Location Manager', icon: <LocationIcon />, path: '/location' },

  { text: 'Push Notifications', icon: <NotificationsIcon />, path: '/notifications' },
  { text: 'Working As', icon: <WorkIcon />, path: '/working-as' },
  { text: 'Qualifications', icon: <SchoolIcon />, path: '/qualifications' },
  { text: 'Working With', icon: <BusinessCenterIcon />, path: '/working-with' },
  { text: 'Religion & Community', icon: <ChurchIcon />, path: '/religion' },
  { text: 'Hobbies', icon: <HobbiesIcon />, path: '/hobbies' },







];

const Sidebar = ({ drawerWidth }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          background: 'linear-gradient(180deg, #e53935 0%, #1e88e5 100%)',
          color: '#fff'
        }
      }}
    >
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              background: 'rgba(255,255,255,0.2)',
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>B</Typography>
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Bihebari Admin
          </Typography>
        </Box>
      </Toolbar>
      <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={() => navigate(item.path)}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.15)'
              },
              backgroundColor: location.pathname === item.path ? 'rgba(255,255,255,0.2)' : 'transparent',
              mb: 0.5,
              mx: 1,
              borderRadius: 2,
            }}
          >
            <ListItemIcon sx={{ color: '#fff', minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
      <List>
        <ListItem 
          button 
          onClick={handleLogout}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.15)'
            },
            mx: 1,
            borderRadius: 2,
          }}
        >
          <ListItemIcon sx={{ color: '#fff', minWidth: 40 }}>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;